import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { CustomerProvider } from "@/context/CustomerContext";
import AuthDialog from "@/components/AuthDialog";
import FavoritesDialog from "@/components/FavoritesDialog";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";
import "@/App.css";

function App() {
  return (
    <CustomerProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pago/exito" element={<PaymentSuccess />} />
            <Route path="/pago/cancelado" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/restablecer" element={<ResetPassword />} />
          </Routes>
          <AuthDialog />
          <FavoritesDialog />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </CustomerProvider>
  );
}

export default App;
